import { Crown } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

// The verified founder/admin pubkey — hard-coded so it cannot be spoofed
export const FOUNDER_PUBKEY = '20e7c953439e66f3882ab96fe0faa8ba246d6fb12c03b0cb4e2dc4623b8bcb21';

interface OfficialBadgeProps {
  pubkey: string;
  size?: 'sm' | 'md';
}

/**
 * Shows a "⚡ Official" badge on content published by the verified founder pubkey.
 * Makes impersonation immediately visible — a fake account won't have this badge.
 */
export function OfficialBadge({ pubkey, size = 'sm' }: OfficialBadgeProps) {
  if (pubkey !== FOUNDER_PUBKEY) return null;

  if (size === 'sm') {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-full bg-yellow-500/15 border border-yellow-500/40 text-yellow-400 text-[10px] font-bold leading-none cursor-default select-none">
            <Crown className="h-2.5 w-2.5" />
            Official
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" className="text-xs">
          Published by the verified SkateSpots founder
        </TooltipContent>
      </Tooltip>
    );
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-yellow-500/15 border border-yellow-500/40 text-yellow-400 text-xs font-bold cursor-default select-none">
          <Crown className="h-3.5 w-3.5" />
          Official SkateSpots
        </span>
      </TooltipTrigger>
      <TooltipContent side="top" className="text-xs">
        Published by the verified SkateSpots founder
      </TooltipContent>
    </Tooltip>
  );
}
